import './bootstrap';

// // document.addEventListener('DOMContentLoaded', function () {
//     console.log('app base:: window.a4dAxios', window.a4dAxios);
//     window.__configVO__ = window.a4dAxios.get('{{route("product.configvo", $product->id)}}')
//         .then(response => {
//             console.log('app_base get_configvo', response);
//         });
// // })
